import config from "@/config";
import Axios from "@/utils/Axios";

export const fetchMonkeyTaskStatus = (id: string) =>
  Axios.get(`/engine/status/mk_${id}`, {}, {}, config.aiCreator);

export const fetchTaskStatus = (id: string) =>
  Axios.get(`/engine/status/${id}`, {}, {}, config.aiCreator);
